/* eslint-disable react/no-array-index-key */

import { useTranslation } from 'react-i18next';

export default function SupportSection() {
  const { t } = useTranslation();

  return (
    <div
      className="
      w-full max-w-[328px] lg:max-w-6xl
      bg-white border-[2px] border-[#E4F0F7] rounded-[24px]
      p-4 pr-[95px] lg:p-6
      flex flex-col lg:flex-row gap-4 lg:gap-10 scroll-mt-[200px] sm:scroll-mt-[330px] lg:scroll-mt-[120px]
    "
    >
      <div className="flex-1 pb-3">
        <p
          className="uppercase text-[12px] font-semibold
        tracking-wide text-gray-500 mb-1
          w-[277px] lg:text-[14px]
          lg:w-[509px]
        "
        >
          {t('support.title')}
        </p>
        <h3
          className="font-bold
          text-[20px] leading-6
          w-[277px]
          lg:text-[40px] lg:leading-[48px]
          lg:w-[509px]
        text-black"
        >
          {t('support.subTitle')}
        </h3>

        <div className="flex space-x-1 text-yellow-400">
          {Array(5)
            .fill(0)
            .map(() => (
              <img
                src="/images/icons/starts.svg"
                alt="Support"
                className="w-[24px] sm:w-[32px]"
              />
            ))}
        </div>
      </div>

      <div className="hidden lg:block w-px bg-gray-200 mx-4" />

      <div className="flex flex-col gap-4 justify-center items-start">
        {[t('support.desc1'), t('support.desc2'), t('support.desc3')].map(
          (item, idx) => (
            <div
              key={idx}
              className="
              flex items-center
              gap-2 sm:gap-4
              w-[309px] sm:w-full sm:max-w-[542px]
              md:w-[350px]
              h-6 sm:h-12
              border-l border-[#005FCC]
              pl-6
            "
            >
              <img
                src="/images/icons/option.svg"
                alt="Support"
                className="w-[24px] sm:w-[48px]"
              />
              <p className="text-xs sm:text-sm">{item}</p>
            </div>
          )
        )}
      </div>
    </div>
  );
}
